import React, { useEffect, useState } from "react";
import { toCommas } from "./utils";
import styles from "./Dashboard.module.css";

import Chart from "./Chart";
import apiClient from "../api/client";


import { Check, Bag, Card } from "./Icons";


import { startOfWeek, endOfWeek, startOfYear, endOfYear } from "date-fns";

const Dashboard = () => {
 
  const [weeklySales, setWeeklySales] = useState([]);
  const [yearlySales, setYearlySales] = useState([]);
  const [pendingOrder, setPendingOrder] = useState();
  useEffect(() => {
    fetchWeeklyOrders();
    getPendingOrders();
    getYearlySales();
  }, []);

  const getPendingOrders = async () => {
    const { data } = await apiClient.get("/booking/getPendingBookings");
    setPendingOrder(data);
  };

  const getYearlySales = async () => {
    const start = startOfYear(new Date());
    const end = endOfYear(new Date());

    const { data } = await apiClient.get("/booking/getsalesdaterange", {
      startDate: start,
      endDate: end,
    });
   
    setYearlySales(data?.monthlySales);
  };
  const fetchWeeklyOrders = async () => {
    const start = startOfWeek(new Date());
    const end = endOfWeek(new Date());

    const { data } = await apiClient.get("/booking/getsalesdaterange", {
      startDate: start,
      endDate: end,
    });
  
    setWeeklySales(data?.monthlySales);
  };
  var total = 0;
  weeklySales?.map((order) => {
    order.orderItems.map((item) => {
      total = total + item?.price * item?.qty;
    });
  });

 

 
  // console.log(totalProfit);
  let paymentHistory = [];
  // for (let i = 0; i < invoices.length; i++) {
  //   let history = [];
  //   if (invoices[i].paymentRecords !== undefined) {
  //     history = [...paymentHistory, invoices[i].paymentRecords];
  //     paymentHistory = [].concat.apply([], history);
  //   }
  // }

  // //sort payment history by date
  // const sortHistoryByDate = paymentHistory.sort(function (a, b) {
  //   var c = new Date(a.datePaid);
  //   var d = new Date(b.datePaid);
  //   return d - c;
  // });

  // let totalPaid = 0;
  // for (let i = 0; i < invoices.length; i++) {
  //   if (invoices[i].totalAmountReceived !== undefined) {
  //     totalPaid += invoices[i].totalAmountReceived;
  //   }
  // }

  // let totalAmount = 0;
  // for (let i = 0; i < invoices.length; i++) {
  //   totalAmount += invoices[i].total;
  // }

  // const unpaidInvoice = invoices?.filter(
  //   (invoice) => invoice.status === "Unpaid"
  // );
  // const paid = invoices?.filter((invoice) => invoice.status === "Paid");
  // const partial = invoices?.filter((invoice) => invoice.status === "Partial");

  // if (!user) {
  //   history.push("/login");
  // }

  // if (isLoading) {
  //   return (
  //     <div
  //       style={{
  //         display: "flex",
  //         alignItems: "center",
  //         justifyContent: "center",
  //         flexDirection: "column",
  //         paddingTop: "20px",
  //       }}
  //     >
  //       <Spinner />
  //     </div>
  //   );
  // }

  // if (invoices.length === 0) {
  //   return (
  //     <div
  //       style={{
  //         display: "flex",
  //         alignItems: "center",
  //         justifyContent: "center",
  //         flexDirection: "column",
  //         paddingTop: "20px",
  //       }}
  //     >
  //       {/* <Spinner /> */}
  //       <Empty />
  //       <p style={{ padding: "40px", color: "gray" }}>
  //         Nothing to display. Click the plus icon to start creating
  //       </p>
  //     </div>
  //   );
  // }

  return (
    <div id="layoutSidenav_content">
      <section className={styles.stat}>
        <ul className={styles.autoGrid}>
          <li
            className={styles.listItem}
            style={{ backgroundColor: "#1976d2", color: "white" }}
          >
            <div>
              <p>{toCommas(total.toFixed(2))} QAR</p>
              <h2 style={{ color: "white" }}>Weekly Sales</h2>
            </div>
            <div>
              <Check />
            </div>
          </li>

          

          <li className={styles.listItem}>
            <div>
              <p>{weeklySales?.length}</p>
              <h2>Orders Delivered</h2>
            </div>
            <div>
              <Bag />
            </div>
          </li>

          {/* <li className={styles.listItem}>
            <div>
              <p>{pendingOrder}</p>
              <h2>Order Pending</h2>
            </div>
            <div>
              <Card />
            </div>
          </li> */}
        </ul>
      </section>

      {/* {paymentHistory.length !== 0 && (
        <section>
          <Chart paymentHistory={paymentHistory} />
        </section>
      )} */}
      <section>
        <Chart paymentHistory={yearlySales} />
      </section>

      <section>
        <h1 style={{ textAlign: "center", padding: "30px" }}>
          {/* {paymentHistory.length
            ? "Recent Payments"
            : "No payment received yet"} */}
          Recent orders
        </h1>
        <div>
          <div className={styles.table}>
            <table>
              <tbody>
                {weeklySales?.length !== 0 && (
                  <tr>
                    {/* <th style={{ padding: "15px" }}></th> */}
                    <th style={{ padding: "15px" }}>orderId</th>
                    <th style={{ padding: "15px" }}>Customer Name</th>
                    <th style={{ padding: "15px" }}>Payment Method</th>
                    <th style={{ padding: "15px" }}>Date</th>
                    <th style={{ padding: "15px" }}>Status</th>
                    {/* <th style={{ padding: "15px" }}>Slot</th> */}
                    <th style={{ padding: "15px" }}>Total Amount</th>
                  </tr>
                )}

                {weeklySales?.map((record) => (
                  <tr className={styles.tableRow} key={record._id}>
                    <td>{record._id}</td>
                    <td>{record.user?.name}</td>
                    <td>{record.paymentMethod}</td>
                    <td>{new Date(record.updatedAt).toDateString()}</td>
                    {record.deliveryStatus === "Processing" && (
                      <td
                        style={{
                          backgroundColor: "yellow",
                          textAlign: "center",
                        }}
                      >
                        {record.deliveryStatus}
                      </td>
                    )}
                    {record.deliveryStatus === "Completed" && (
                      <td
                        style={{
                          backgroundColor: "#50C878",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        {record.deliveryStatus}
                      </td>
                    )}
                    {record.deliveryStatus === "Cancelled" && (
                      <td
                        style={{
                          backgroundColor: "red",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        {record.deliveryStatus}
                      </td>
                    )}
                    {record.deliveryStatus === "Accepted" && (
                      <td
                        style={{
                          backgroundColor: "#0096FF",
                          color: "white",
                          textAlign: "center",
                        }}
                      >
                        {record.deliveryStatus}
                      </td>
                    )}
                    {/* <td>{record?.deliverySlot}</td> */}
                    <td>{record?.totalPrice} QAR</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dashboard;
